<template>
    <div>
        <el-dialog title="VIP申请" :visible.sync="vipApplyDialog" width="70%" top="8vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
            <el-card>
                <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                    style="margin:auto;width:calc(100% - 30px)" height="500" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.5' }"
                    :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
                    <el-table-column label="商户名称" width="150" align="center" prop="bsName"></el-table-column>
                    <el-table-column label="申请前免费时长" width="150" align="center" prop="beforeVipTime"></el-table-column>
                    <el-table-column label="申请后免费时长" width="150" align="center" prop="afterVipTime"></el-table-column>
                    <el-table-column label="申请前VIP个数" width="150" align="center" prop="beforeVipNum"></el-table-column>
                    <el-table-column label="申请后VIP个数" width="150" align="center" prop="afterVipNum"></el-table-column>
                    <el-table-column label="申请原因" width="150" align="center" prop="applyReason"></el-table-column>
                    <el-table-column label="申请时间" width="180" align="center">
                        <template slot-scope="scope">{{scope.row.applyTime | formatDate}}</template>
                    </el-table-column>
                    <el-table-column label="申请人" width="150" align="center" prop="csName"></el-table-column>
                    <el-table-column label="操作" width="150" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="warning" size="small" plain @click="approval(scope.row.id)">审核</el-button>
                            <el-button type="warning" size="small" plain @click="id = scope.row.id,refuseDialog = true">拒绝</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
            </el-card>
        </el-dialog>
        <el-dialog title="拒绝申请" :visible.sync="refuseDialog" width="30%" top="25vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog" :show-close="false">
            <el-card style="height: 150px">
               <el-input type="textarea" :rows="5" placeholder="拒绝原因" v-model="reason"></el-input>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button style="background-color:#A9F5F2;margin: 0" @click="refuseDialog = false">取消</el-button>
                <el-button style="background-color:#A9F5A9" @click="refuse">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getAllVipModifyApply, approvalVipModifyApply} from '../../api/usermanagement/bsList.js'
import { formatDate } from "../../utils/date";
export default {
    data() {
        return {
            request: {
                current: '',
                size: ''
            },
            query: {current: 1,size: 10},
            response: {data: [],total: 0},
            vipApplyDialog: false,
            loading: false,
            refuseDialog: false,
            id: '',
            reason: ''

        }
    },
    methods: {
        init(){
            this.vipApplyDialog = true;
            this.request.current = this.query.current;
            this.request.size = this.query.size;
            getAllVipModifyApply(this.request).then(result=>{
                this.response.data = result.data.records;
                this.response.total = result.data.total;
            })
        },

        /**
         * 审核申请
         */
        approval(id){
            approvalVipModifyApply({applyId: id , operationType: '1'}).then(result=>{
                this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
                this.init();
            })
        },

        /**
         * 拒绝申请
         */
        refuse(){
            approvalVipModifyApply({applyId: this.id , operationType: '-1', reason: this.reason}).then(result=>{
                this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
                this.refuseDialog = false;
                this.init();
            })
        },

        /**
         * 页码改变触发事件
         */
        currenChangeHandle(value) {
        this.query.current = value;
        this.init()
        },
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
}
</script>
<style scoped>
.el-pagination{
    margin-left: 28%;
}
</style>


// WEBPACK FOOTER //
// src/pages/usermanagement/vipApply.vue